import Swiper, { Navigation } from 'swiper';
import 'swiper/css';

/**
 * @returns {Class} New Constructor
 */
Array.prototype.forEach.call(document.querySelectorAll('[data-module]'), element => {
  const keys = element.getAttribute('data-module').split(/\s+/)
  const opts = element.getAttribute('data-options') || null

  keys.forEach(key => {
    import(`./modules/_${key.charAt(0).toUpperCase() + key.slice(1)}`).then(
      module => {
        const options = opts ? keys.length > 1 ? JSON.parse(opts)[key] : JSON.parse(opts) : {}
        if (module !== void 0) return new module.default(element, options)
      }
    )
  })
})

let topSlider

window.addEventListener('load', function() {
  // addScrollFadein()

  // Member詳細ページのみ行う処理
  if(location.pathname.includes('/aaas/atl/about/member/detail/')){
    addMemberDetailSliderControl()
  }
})

// function addScrollFadein() {
//   const targetElms = $('.js-scroll-fade-wrap')
//   let targetElmPosAry = []
//   let targetElmFlgAry = []

//   targetElms.each(function (i, elm) {
//     targetElmPosAry.push($(elm).offset().top)
//     targetElmFlgAry.push(false)
//   })

//   window.addEventListener('scroll', function(){
//     const currentScrollY = window.scrollY
//     for(let i=0; i<targetElmPosAry.length; i++){
//       if(!targetElmFlgAry[i]){
//         if(currentScrollY + (window.innerHeight * 0.7) >= targetElmPosAry[i]){
//           $(targetElms).eq(i).addClass('is-active')
//         }
//       }
//     }
//   })
// }

function addMemberDetailSliderControl(){
  topSlider = new Swiper(".swiper", {
    modules: [ Navigation ],
    slidesPerView: 1,
    spaceBetween: 48,
    freeMode: true,
    navigation: {
      nextEl: '.swiper__member__detail__btn.is-next',
      prevEl: '.swiper__member__detail__btn.is-prev',
    },
    breakpoints: {
      // 769px以上の場合
      769: {
        slidesPerView: 3,
        initialSlide: 0
      },
    }
  });
}
